(() => {
  const script = document.currentScript;
  const motionEnabled = script?.dataset.motionEnabled !== 'false';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!motionEnabled || reducedMotion || !('IntersectionObserver' in window)) return;

  const revealSelector = [
    '.buskins-benefits__item',
    '.buskins-categories__heading',
    '.buskins-category-card',
    '.buskins-colour-shop__heading',
    '.buskins-colour-shop__story',
    '.buskins-colour-shop__mobile-hint',
    '.buskins-featured-products__heading',
    '.buskins-product-card',
    '.buskins-featured-products__footer',
    '.buskins-product__preview-note',
    '.buskins-product__gallery',
    '.buskins-product__identity',
    '.buskins-product__purchase',
    '.buskins-product__details',
    '.buskins-product-recommendations__heading',
    '.buskins-shop-edit__heading',
    '.buskins-shop-edit__media',
    '.buskins-shop-edit__product',
    '.buskins-story__content > div',
    '.buskins-confidence__heading',
    '.buskins-confidence__item',
    '.buskins-campaign__content > div',
    '.buskins-campaign__media',
    '.buskins-social__heading',
    '.buskins-social__card',
    '.buskins-faq__heading',
    '.buskins-faq__item',
    '.buskins-newsletter__heading',
    '.buskins-newsletter__form'
  ].join(',');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    }
  );

  const prepare = (root = document) => {
    const targets = root.querySelectorAll(revealSelector);

    targets.forEach((target, index) => {
      if (target.dataset.buskinsMotionReady === 'true') return;
      target.dataset.buskinsMotionReady = 'true';
      target.classList.add('buskins-reveal');
      target.style.setProperty('--buskins-reveal-delay', `${(index % 4) * 55}ms`);
      observer.observe(target);
    });
  };

  document.documentElement.classList.add('buskins-motion-ready');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  } else {
    prepare();
  }

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
